import { Box } from "@mui/material";
import Titre from "../../component/titre/titre";

export default function FaqPage(){

    return (
        <Box margin="20px">
            <Box display="flex" justifyContent="Space-between">
                <Titre title="Faq" subtitle="Faq page"/> 

            </Box>
        </Box>
    )
}  